/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventlocationpendinghint3Inputs */

const en_eventlocationpendinghint3 = /** @type {(inputs: Eventlocationpendinghint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The city is enough. You can add the exact address later.`)
};

const de_eventlocationpendinghint3 = /** @type {(inputs: Eventlocationpendinghint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Stadt reicht. Die genaue Adresse kannst du später ergänzen.`)
};

/**
* | output |
* | --- |
* | "The city is enough. You can add the exact address later." |
*
* @param {Eventlocationpendinghint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventlocationpendinghint3 = /** @type {((inputs?: Eventlocationpendinghint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventlocationpendinghint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventlocationpendinghint3(inputs)
	return de_eventlocationpendinghint3(inputs)
});
export { eventlocationpendinghint3 as "eventLocationPendingHint" }